import Grid from "@mui/material/Grid";
import { Status } from "../../../../../types/campaigns";
import { styled } from "@mui/system";

const Div = styled("div")({});

interface ReachProps {
  data?: Status[];
}

export default function Reach({ data }: ReachProps) {
  const icon = (param: string) => {
    switch (param.toUpperCase()) {
      case "EM ESPERA":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/em_espera.svg";
      case "ENGAJAMENTO":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/01-engajamento.svg";
      case "REAÇÕES":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/03-reacoes.svg";
      case "VISUALIZAÇÕES":
      case "MENSAGEM ENTREGUE":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/03-visualizacoes.svg";
      case "COMENTÁRIOS":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/04-comentarios.svg";
      case "CONTAS ATINGIDAS":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/02-alcance.svg";
      case "ALCANCE":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/02-alcance.svg";
      case "CLICKS":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/taxa-cliques.png";
      case "IMPRESSÕES":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/03-visualizacoes.svg";
      default:
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/em_espera.svg";
    }
  };

  return (
    <Grid
      item
      style={{
        marginTop: "2rem",
      }}
    >
      <Grid container spacing={2}>
        {data &&
          data.map((dt, index) => (
            <Grid key={index} item xs={5.9} spacing={5}>
              <Div
                style={{
                  display: "flex",
                  border: "1px solid #D3D5DB",
                  width: "100%%",
                  padding: "16px",
                }}
              >
                <Div>
                  <img src={icon(dt.status_envio_externo)} alt="icon" />
                </Div>
                <Div
                  style={{
                    marginLeft: "8px",
                    fontSize: "14px",
                    fontWeight: 600,
                    lineHeight: "22px",
                    letterSpacing: "0.05em",
                    color: "#1E1F21",
                  }}
                >
                  <Div>{dt.quantidade as number}</Div>
                  <Div
                    style={{
                      fontWeight: 500,
                      fontSize: "14px",
                      lineHeight: "20px",
                      color: "#616161",
                    }}
                  >
                    {dt.status_envio_externo}
                  </Div>
                </Div>
              </Div>
            </Grid>
          ))}
      </Grid>
    </Grid>
  );
}
